<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
      <div class="card contact-us-card shadow-lg border-0">
        <div class="card-body p-4 p-md-5">
          <!-- Header Section -->
          <div class="text-center mb-4">
            <div class="contact-us-icon mb-3">
              <i class="fa fa-envelope fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold mb-2">{{ "CONTACT_US.TITLE" | translate }}</h2>
            <p class="text-muted mb-0">{{ "CONTACT_US.SUBTITLE" | translate }}</p>
          </div>

          <form [formGroup]="contactForm" (ngSubmit)="contactUs()" novalidate>

            <!-- Personal Information -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="firstname" class="form-label">
                  <i class="fa fa-user me-2 text-muted"></i>{{ "CONTACT_US.FIRST_NAME_LABEL" | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-user text-muted"></i>
                  </span>
                  <input
                    formControlName="firstname"
                    type="text"
                    class="form-control border-start-0"
                    [class.is-invalid]="contactForm.get('firstname')?.errors && contactForm.get('firstname')?.touched"
                    id="firstname"
                    [placeholder]="'CONTACT_US.FIRST_NAME_PLACEHOLDER' | translate"
                    autocomplete="given-name"
                  />
                  <div class="invalid-feedback" *ngIf="contactForm.get('firstname')?.touched && contactForm.get('firstname')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ "CONTACT_US.FIRST_NAME_REQUIRED" | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lastname" class="form-label">
                  <i class="fa fa-user me-2 text-muted"></i>{{ "CONTACT_US.LAST_NAME_LABEL" | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-user text-muted"></i>
                  </span>
                  <input
                    formControlName="lastname"
                    type="text"
                    class="form-control border-start-0"
                    [class.is-invalid]="contactForm.get('lastname')?.errors && contactForm.get('lastname')?.touched"
                    id="lastname"
                    [placeholder]="'CONTACT_US.LAST_NAME_PLACEHOLDER' | translate"
                    autocomplete="family-name"
                  />
                  <div class="invalid-feedback" *ngIf="contactForm.get('lastname')?.touched && contactForm.get('lastname')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ "CONTACT_US.LAST_NAME_REQUIRED" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Information -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="email" class="form-label">
                  <i class="fa fa-envelope me-2 text-muted"></i>{{ "CONTACT_US.EMAIL_LABEL" | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-envelope text-muted"></i>
                  </span>
                  <input
                    formControlName="email"
                    type="email"
                    class="form-control border-start-0"
                    [class.is-invalid]="contactForm.get('email')?.errors && contactForm.get('email')?.touched"
                    id="email"
                    [placeholder]="'CONTACT_US.EMAIL_PLACEHOLDER' | translate"
                    autocomplete="email"
                  />
                  <div class="invalid-feedback" *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ "CONTACT_US.EMAIL_REQUIRED" | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.hasError('pattern') && !contactForm.get('email')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ "CONTACT_US.EMAIL_INVALID" | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="phone" class="form-label">
                  <i class="fa fa-phone me-2 text-muted"></i>{{ "CONTACT_US.PHONE_LABEL" | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-phone text-muted"></i>
                  </span>
                  <input
                    formControlName="phone"
                    type="tel"
                    class="form-control border-start-0"
                    [class.is-invalid]="contactForm.get('phone')?.errors && contactForm.get('phone')?.touched"
                    id="phone"
                    [placeholder]="'CONTACT_US.PHONE_PLACEHOLDER' | translate"
                    autocomplete="tel"
                  />
                </div>
              </div>
            </div>

            <!-- Message Section -->
            <div class="mb-4">
              <label for="comment" class="form-label">
                <i class="fa fa-comment me-2 text-muted"></i>{{ "CONTACT_US.COMMENT_LABEL" | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text border-end-0 bg-light align-self-start">
                  <i class="fa fa-comment text-muted"></i>
                </span>
                <textarea
                  formControlName="comment"
                  rows="5"
                  class="form-control border-start-0"
                  [class.is-invalid]="contactForm.get('comment')?.errors && contactForm.get('comment')?.touched"
                  id="comment"
                  [placeholder]="'CONTACT_US.COMMENT_PLACEHOLDER' | translate"
                  style="resize: vertical; min-height: 120px;"
                ></textarea>
                <div class="invalid-feedback" *ngIf="contactForm.get('comment')?.touched && contactForm.get('comment')?.hasError('required')">
                  <i class="fa fa-exclamation-circle me-1"></i>{{ "CONTACT_US.COMMENT_REQUIRED" | translate }}
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="d-grid mb-4">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                [disabled]="!contactForm.valid"
              >
                <i class="fa fa-paper-plane me-2"></i>{{ "CONTACT_US.SEND_BUTTON" | translate }}
              </button>
            </div>


          </form>
        </div>
      </div>
    </div>
  </div>
</div>
